import RosterItemWithSummarizedBookings from './RosterItemWithSummarizedBookings';

export default class AbstractRosterShift extends RosterItemWithSummarizedBookings {
  shouldBeRemoved() {
    return this.start.isSame(this.end);
  }

  createNew(start, end, hasActuals) {
    throw 'Should be implemented by subclass';
  }

  addBreak(breakItem) {
    /* There are three options that can happen:
      1) The break starts exactly at the front of the shift/no roster => in that case we need to move up the start of the shift/no roster to the end of the break
      2) The break ends exactly at the end of the shift/no roster => in that case we need to set the end of the shift/no roster at the start of the break
      3) The break splits up the shift/no roster: we set the end of this shift/no roster to the start of the break and result in a new shift/no roster for the part after the break is returned */

    const breakStart = breakItem.start;
    const breakEnd = breakItem.end;
    const overlapStart = breakStart.isBefore(this.start) ? this.start : breakStart;
    const overlapEnd = breakEnd.isAfter(this.end) ? this.end : breakEnd;

    // Option 1: break exactly at the beginning of the shift/no roster
    if (overlapStart.isSame(this.start)) {
      this.start = overlapEnd;
      return null;
    }

    // Option 2: break exactly at the end of the shift/no roster
    if (overlapEnd.isSame(this.end)) {
      this.end = overlapStart;
      return null;
    }

    // Option 3: break splits up the shift/no roster
    const newItem = this.createNew(overlapEnd, this.end, this.hasActuals);
    this.end = overlapStart;

    return newItem;
  }
}
